// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `hr {
  border: 0;
  margin-bottom: 10px;
  border-top: 1px solid var(--color-bg-dark);
}
`, "",{"version":3,"sources":["webpack://./src/context/focusPeriod/focusPeriod.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,mBAAmB;EACnB,0CAA0C;AAC5C","sourcesContent":["hr {\n  border: 0;\n  margin-bottom: 10px;\n  border-top: 1px solid var(--color-bg-dark);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
